document.addEventListener('DOMContentLoaded', function () {
	initLogin()
	initClickAttribute()
	initMainSwiper()
	initMainNav()
	initFancyBox()
	initSwiper()
	initBasket()
	initCounter()
	initTabs()
	initFormValidation()
	initPlaceholder()
	initTextOverflowHidden()
	initAnimationCounter()
	initMenu()
	initMainCatalog()
	initDropDown()
	initOpenCloseCard()
	initCardBuy()
	initAccordionSlider()
	initAddModifation()
	initRating()
	initProfile()
	initDragDrop()
	initInputEye()
	popupCounter()
	popupCheck()
	popupTotal()
	initPopupsClearDN()
	initProductFilter()
	initRangeSlider()
	initDate()
	initMgBurger()
	mgCheckStatus()
	mgSlideUpDown()
	mgCheckSucess()
	popupSlide()
	validationSocial()
	initOrderingPage()
	// overlapDoorInInterior()

	closeCardCompares()
	inputMaskCustom()

	autoCallerFortunaModal()
	fortunaData()

	hiddenUnselectMI()
	disabledCheckboxBlocks()
	toggleFormsVisibility('Юридическое лицо')

	// mgCrop();
	// initActiveSelectResize();
	//toggleAccordion();
	// initSearch();
	// initSelectCity();
	// popupSelect();
	// initOpenClose();
})
